<template>
    <div class="modal-fair">
        <div class="fair-header">
            <div class="header-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" stroke="currentColor" stroke-width="2"/>
                    <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <h1 class="header-title">Provably Fair</h1>
            <p class="header-subtitle">Transparent & verifiable gaming</p>
        </div>
        
        <div class="fair-info">
            <p>The game results have been generated before you even place your bet, and most importantly, we can prove it. Before each game, we actually give you the game result in a hashed format.</p>
            <p>Before you start the game, we give you the hash of the server seed and the public seed which the round result is based on. After the game is finished, we publish the server seed, which you can then compare to the hash to make sure that they match. With this system we can prove that the results were fair and pre-generated.</p>
        </div>
        
        <div class="fair-nav">
            <button v-on:click="modalSetGame('Crash')" v-bind:class="{ 'button-active': modalGame === 'Crash' }">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23 6l-9.5 9.5-5-5L1 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M17 6h6v6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Crash</span>
            </button>
            <button v-on:click="modalSetGame('Mines')" v-bind:class="{ 'button-active': modalGame === 'Mines' }">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                    <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/>
                    <path d="M12 2v4M12 18v4M2 12h4M18 12h4" stroke="currentColor" stroke-width="2"/>
                </svg>
                <span>Mines</span>
            </button>
            <button v-on:click="modalSetGame('Towers')" v-bind:class="{ 'button-active': modalGame === 'Towers' }">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 21h18M5 21V7l7-4 7 4v14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 21v-6h6v6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 9h.01M15 9h.01M9 13h.01M15 13h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <span>Towers</span>
            </button>
            <button v-on:click="modalSetGame('Blackjack')" v-bind:class="{ 'button-active': modalGame === 'Blackjack' }">
                <svg width="18" height="18" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.94516 13.5723H8.3042L8.60583 12.7756L8.94516 13.5723ZM2.59212 1.26538C2.96915 2.15583 3.34619 3.04628 3.73265 3.93673C3.83633 4.20855 3.44045 4.37727 3.32734 4.10545L2.97858 3.29936H1.86632C1.78149 3.53368 1.67781 3.843 1.57412 4.07733C1.42331 4.41476 1.06512 4.18981 1.14996 3.9461C1.49871 3.04628 1.83805 2.15583 2.17738 1.256C2.25278 1.06854 2.52614 1.06854 2.59212 1.26538ZM10.1517 0H0.838903C0.377035 0 0 0.374927 0 0.843585V15.1564C0 15.6157 0.377035 16 0.838903 16H10.1517C10.623 16 11 15.6157 11 15.1564V0.843585C11 0.374927 10.623 0 10.1517 0ZM6.32476 4.89279C6.51328 4.89279 6.61697 5.10838 6.49443 5.24897C6.32476 5.49268 6.21165 6.17692 6.17395 6.43937C6.85261 6.43937 7.38046 6.6362 7.74807 7.24546C8.5587 8.61394 6.79606 10.1886 5.80634 10.9291C5.42931 11.2197 5.43873 11.126 5.10883 10.8448C4.36418 10.2168 2.94087 8.91388 3.02571 7.9297C3.11054 7.01113 3.92117 6.36438 4.82605 6.43937L4.81662 6.41125C4.8072 6.33626 4.64696 5.5208 4.54327 5.29584C4.49614 5.18336 4.32648 4.94903 4.62811 4.89279C4.92031 4.84593 5.95716 4.89279 6.32476 4.89279ZM7.44644 14.5847C7.76692 13.7598 8.07798 12.935 8.38903 12.1101C8.46444 11.9227 8.73779 11.9227 8.80377 12.1195C9.15253 12.9443 9.50129 13.7598 9.85004 14.5753C9.96315 14.8377 9.55784 15.0064 9.44473 14.744L9.13368 14.0129H8.13453C8.0497 14.2378 7.95544 14.5284 7.86118 14.744C7.7575 15.0064 7.34276 14.8565 7.44644 14.5847ZM2.79006 2.85882H2.03599L2.39417 1.9215L2.79006 2.85882Z" fill="currentColor"/>
                </svg>
                <span>Blackjack</span>
            </button>
        </div>
        
        <div class="fair-content">
            <component v-bind:is="'Fair' + modalGame" />
        </div>
    </div>
</template>

<script>
    import FairCrash from '@/components/fair/FairCrash';
    import FairMines from '@/components/fair/FairMines';
    import FairTowers from '@/components/fair/FairTowers';
    import FairBlackjack from '@/components/fair/FairBlackjack';

    export default {
        name: 'ModalFair',
        components: {
            FairCrash,
            FairMines,
            FairTowers,
            FairBlackjack
        },  
        data() {
            return {
                modalGame: 'Crash'
            }
        },
        methods: {
            modalSetGame(game) {
                this.modalGame = game;
            }
        }
    }
</script>

<style scoped>
    .modal-fair {
        width: 860px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px;
        border-radius: 20px;
        background: var(--bg-blue-dark, #1e2238);
        border: 1px solid rgba(255, 255, 255, 0.08);
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
    }

    .modal-fair .fair-header {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 24px;
    }

    .modal-fair .header-icon {
        width: 72px;
        height: 72px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.08);
        border: 1px solid rgba(255, 255, 255, 0.12);
        color: #ffffff;
        margin-bottom: 20px;
    }

    .modal-fair .header-title {
        font-size: 26px;
        font-weight: 700;
        color: #ffffff;
        letter-spacing: 0.02em;
        margin: 0;
        text-transform: none;
    }

    .modal-fair .header-subtitle {
        margin-top: 8px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.6);
    }

    .modal-fair .fair-info {
        width: 100%;
        padding: 24px;
        background: rgba(255, 255, 255, 0.04);
        border-radius: 14px;
        border: 1px solid rgba(255, 255, 255, 0.08);
        margin-bottom: 28px;
    }

    .modal-fair .fair-info p {
        font-size: 14px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.85);
        line-height: 1.7;
        margin: 0;
    }

    .modal-fair .fair-info p + p {
        margin-top: 12px;
    }

    .modal-fair .fair-nav {
        display: flex;
        gap: 8px;
        padding: 6px;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 14px;
        border: 1px solid rgba(255, 255, 255, 0.06);
    }

    .modal-fair .fair-nav button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        height: 48px;
        padding: 0 28px;
        border-radius: 10px;
        background: transparent;
        border: none;
        cursor: pointer;
        transition: all 0.25s ease;
        color: rgba(255, 255, 255, 0.6);
    }

    .modal-fair .fair-nav button:hover {
        background: rgba(255, 255, 255, 0.06);
        color: rgba(255, 255, 255, 0.9);
    }

    .modal-fair .fair-nav button.button-active {
        background: var(--accent-btn-purple, #6366f1);
        color: #ffffff;
        box-shadow: 0 4px 16px rgba(99, 102, 241, 0.35);
    }

    .modal-fair .fair-nav button span {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.02em;
    }

    .modal-fair .fair-nav button svg {
        flex-shrink: 0;
    }

    .modal-fair .fair-content {
        width: 100%;
        margin-top: 28px;
    }

    @media only screen and (max-width: 955px) {
        .modal-fair {
            width: calc(100vw - 20px);
            padding: 85px 20px 40px 20px;
        }
    }

    @media only screen and (max-width: 600px) {
        .modal-fair .fair-nav {
            width: 100%;
            flex-direction: column;
            gap: 4px;
        }

        .modal-fair .fair-nav button {
            width: 100%;
            padding: 0 20px;
        }

        .modal-fair .header-title {
            font-size: 24px;
        }

        .modal-fair .fair-info {
            padding: 16px;
        }

        .modal-fair .fair-info p {
            font-size: 13px;
        }
    }
</style>
